import React, { useState } from "react";
import Select, { components } from "react-select";

const SelectBox = (props) => {
  const {
    paint,
    noRadius,
    options,
    handleChange,
    handleDelete,
    defaultValue,
    placeholder,
    minHeight,
    mainColor,
    subColor,
    emptyColor,
    onlyTxt,
    deleteMode,
  } = props;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isSelected
        ? mainColor
        : state.isFocused
        ? mainColor
        : emptyColor,
      boxShadow: state.isFocused ? `0 0 0 2px ${mainColor}` : null,
      minHeight: "32px",
      height: minHeight ? "32px" : null,
      borderRadius: noRadius ? "" : "2rem",
      backgroundColor: paint ? subColor : "transparent",
      color: mainColor,
    }),
    option: (provided, state) => ({
      ...provided,
      display: deleteMode ? "flex" : "",
      justifyContent: deleteMode ? "space-between" : "",
      borderColor: state.isSelected
        ? mainColor
        : state.isFocused
        ? mainColor
        : emptyColor,
      backgroundColor:
        (state.isSelected || state.isFocused) && paint
          ? subColor
          : state.isFocused || state.isSelected
          ? subColor
          : "white",
      minHeight: "32px",
      height: minHeight ? "32px" : null,
      color: state.isSelected || state.isFocused ? "white" : subColor,
    }),
    menuPortal: (provided, state) => ({
      ...provided,
      fontSize: "10px",
      color: subColor,
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: paint ? mainColor : subColor,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: paint ? mainColor : subColor,
    }),
  };

  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        {props.data.label}
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(props.data);
            setMenuIsOpen(false);
          }}
          style={{ marginLeft: "10px", color: "red", cursor: "pointer" }}
        >
          &#x2716; {/* X mark */}
        </div>
      </components.Option>
    );
  };
  return (
    <Select
      value={defaultValue}
      className="custom-select"
      options={options}
      onChange={handleChange}
      styles={customStyles}
      defaultValue={defaultValue}
      placeholder={placeholder}
      menuPlacement="auto"
      menuIsOpen={menuIsOpen}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={() => setMenuIsOpen(false)}
      components={
        onlyTxt
          ? {
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }
          : deleteMode
          ? { Option: CustomOption }
          : null
      }
    />
  );
};

export default SelectBox;
